@import "styles/variables";

.numberselect {
  align-self: center;
  display: block;
  position: relative;
  padding-left: 22px;
  margin-bottom: 24px;
  cursor: pointer;  
}
.numberselect ~ label {
  opacity: 0.6;
}
.numberselect-button {
  position: absolute;
  z-index: -1;
  opacity: 0;  
}
.numberselect-indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 16px;
  width: 16px;
  box-sizing: content-box;
  background-color: var(--color-white);
  border: solid 1px var(--color-grey);
  font-size: var(--font-size-medium);
  font-family: var(--font-stack-bold);  
}
.numberselect-button:focus ~ .numberselect-indicator {
  border-color: var(--color-yellow);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}
.numberselect-button:focus ~ .numberselect-indicator:before {
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
}
.numberselect-button:focus ~ .numberselect-indicator:not([data-value="0"]) {
  border-color: var(--color-border-orange-focus);
}
.numberselect-indicator:after {
  content: attr(data-value);
  position: absolute;
  display: none;
  top: 0;
  line-height: 16px;
  width: 100%;  
  text-align: center;
}
.numberselect-indicator:not([data-value="0"]) {
  background: var(--color-yellow);
  border-color: var(--color-yellow);
}
.numberselect-indicator:not([data-value="0"]):after {
  display: block;
}
.numberselect-indicator[data-value="1"]:before {
  position: absolute;
  display: block;
  content: '2';
  top: -1px;
  left: -20px;
  line-height: 16px;
  width: 100%;  
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
  background-color: var(--color-grey);
  border: solid 1px var(--color-grey);
}